export default [
  {
    NombreCentroMedico: "CMC DEMo",
    Especialidad: "Odontología",
    Fecha: "2024-01-04 12:15 am",
    idCita: 123456,
    EnCentroMedico: true
  },
  {
    NombreCentroMedico: "CMC DEMo",
    Especialidad:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum",
    Fecha: "2021-01-15 2:00 pm",
    idCita: 23423,
    EnCentroMedico: true
  },
  {
    NombreCentroMedico: "CMC BOCAGRANDE",
    Especialidad: "Odontología",
    Fecha: "2021-01-16 10:00 am",
    idCita: 123458,
    EnCentroMedico: true
  },
  {
    NombreCentroMedico: "CMC BOCAGRANDE",
    Especialidad: "Odontología",
    Fecha: "2021-01-17 10:00 am",
    idCita: 123459,
    EnCentroMedico: false
  },
  {
    NombreCentroMedico: "CMC BOCAGRANDE",
    Especialidad: "Odontología",
    Fecha: "2021-01-18 10:00 am",
    idCita: 123460,
    EnCentroMedico: false
  }
];
